import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaFontSize } from 'yoda-ui/yodaTheme';

export const EventListSelectStyle: SxProps<Theme> = {
  height: '30px',
  fontSize: YodaFontSize.small,
};
